module.exports = __webpack_public_path__ + "img/smart-security.535ccf88.svg";